import apiConfig from '../../config/apiConfig';
import { apiBaseURL, toastifyType, viewsActionType } from '../../constants';
import { addTost } from './toastAction';


export const fetchCustomColumnsViews = (sectionName, searchValue, setTotalRecords, setTotalPage, getObjId, portfolioId) => async (dispatch) => {
    try {
        const response = await apiConfig.post(apiBaseURL.VIEWS + '/fields/custom', {
            section: sectionName,
            name: searchValue,
            nin: getObjId,
            portfolioId
        })
        setTotalRecords && setTotalRecords(response.data?.data?.totalRecords)
        setTotalPage && setTotalPage(response.data?.data?.totalPage)
        dispatch({ type: viewsActionType.CUSTOM_FIELD, payload: response.data?.data });
    } catch (error) {
        dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }))
    }
}


export const newFetchCustomColumnsViews = (sectionName, searchValue, getObjId, portfolioId, setLoading) => async (dispatch) => {
    try {
        setLoading(true);
        const response = await apiConfig.post(apiBaseURL.VIEWS + '/fields/custom', {
            section: sectionName,
            name: searchValue,
            nin: getObjId,
            portfolioId
        })
        setLoading(false);
        return response?.data?.data;
    } catch (error) {
        setLoading(false);
        dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }))
        console.log(error);

    }
}

